import Vue from "vue";
import axios from "axios";
import { noTenant, withTenant, authHeader } from "./AuthHeader";
import { env } from "../config/env";
import { date } from 'quasar';
import { telehealth } from "src/store/sgh/getters";
import { redirectToDigitalLogin } from "../utils/safeRedirect";

const apiUrl = env.CORE_API_URL;

let appointmentTypesCache = null;
let appointmentTypesPromise = null;

class SGHService {
  findProfissionais(payload) {
    
    return Vue.prototype.$axios.get(apiUrl + "/profissional-sgh/profissionais", {
      params: {
        agenda: payload.agenda,
        convenio: payload.convenio,
        crm: payload.crm,
        data: payload.data,
        especialidade: payload.especialidade,
        nome: payload.nome,
        subTenant4Health: payload.subTenant4Health,
        tenant: payload.tenant,
        d4HToken: payload.d4HToken,
        telehealth: payload.telehealth  
      },
      headers: noTenant()
    });
  }

   findProfissionaisCallCenter(payload, cancelToken) {
    return Vue.prototype.$axios.get(apiUrl + "/profissional-sgh/profissionais-call-center", {
      params: {
        agenda: payload.agenda,
        convenio: payload.convenio,
        crm: payload.crm,
        data: payload.data,
        especialidade: payload.especialidade,
        nome: payload.nome,
        subTenant4Health: payload.subTenant4Health,
        tenant: payload.tenant,
        d4HToken: payload.d4HToken,
        telehealth: payload.telehealth
      },
      headers: noTenant(),
      cancelToken
    });
  }

  findConvenioByProfissionais(payload) {
    
    return Vue.prototype.$axios.get(apiUrl + "/profissional-sgh/profissionais", {
      params: {
        agenda: payload.agenda,
        convenio: payload.convenio,
        crm: payload.crm,
        data: payload.data,
        especialidade: payload.especialidade,
        nome: payload.nome,
        subTenant4Health: payload.subTenant4Health,
        tenant: payload.tenant,
        d4HToken: payload.d4HToken,
        telehealth: payload.telehealth
      },
      headers: noTenant()
    });
  }

    findConvenioByProfissionaisCallCenter(payload) {
    return Vue.prototype.$axios.get(apiUrl + "/profissional-sgh/profissionais-call-center", {
      params: {
        agenda: payload.agenda,
        convenio: payload.convenio,
        crm: payload.crm,
        data: payload.data,
        especialidade: payload.especialidade,
        nome: payload.nome,
        subTenant4Health: payload.subTenant4Health,
        tenant: payload.tenant,
        d4HToken: payload.d4HToken
      },
      headers: noTenant()
    });
  }

  findAgendas(payload) {
    
    return Vue.prototype.$axios.get(apiUrl + "/profissional-sgh/agendas", {
      params: {
        convenio: payload.convenio,
        crm: payload.crm,
        data: payload.data,
        especialidade: payload.especialidade,
        nome: payload.nome,
        subTenant4Health: payload.subTenant4Health,
        tenant: payload.tenant,
        d4HToken: payload.d4HToken,
        telehealth: payload.telehealth
      },
      headers: noTenant()
    });
  }

  findAgendasCallCenter(payload) {

    return Vue.prototype.$axios.get(apiUrl + "/profissional-sgh/agendas-call-center", {
      params: {
        convenio: payload.convenio,
        crm: payload.crm,
        data: payload.data,
        especialidade: payload.especialidade,
        nome: payload.nome,
        subTenant4Health: payload.subTenant4Health,
        tenant: payload.tenant,
        d4HToken: payload.d4HToken,
        telehealth: payload.telehealth
      },
      headers: noTenant()
    });
  }

  findDatasCallCenter(payload) {
    const dataInicio = Date.now()
    const dataInicioFormatada = date.formatDate(dataInicio, 'YYYY-MM-DD')

    return Vue.prototype.$axios.get(apiUrl + "/agendamento-sgh/datas-horarios-call-center", {
      params: {
        agenda: payload.agenda,
        conselho: payload.conselho,
        convenio: payload.convenio,
        dataInicial: dataInicioFormatada,
        especialidade: payload.especialidade,
        localizacao: payload.localizacao,
        subTenant4Health: payload.subTenant4Health,
        tenant: payload.tenant,
        d4HToken: payload.d4HToken
      },
      headers: noTenant()
    });
  }

  findDatasCallCenterPorData(payload) {
    return Vue.prototype.$axios.get(apiUrl + "/agendamento-sgh/datas-horarios-call-center", {
      params: {
        agenda: payload.agenda,
        conselho: payload.conselho,
        dataInicial: payload.dataInicial,
        subTenant4Health: payload.subTenant4Health,
        tenant: payload.tenant,
        d4HToken: payload.d4HToken
      },
      headers: noTenant()
    });
  }

  findAgendamentos(payload) {
    return Vue.prototype.$axios.get(apiUrl + "/agendamento-sgh/agendas-call-center", {
      params: {
        conselho: payload.conselho,
        convenio: payload.convenio,
        telehealth: payload.telehealth,
        cpfPaciente: payload.cpfPaciente,
        dataFinal: payload.dataFinal,
        dataInicial: payload.dataInicial,
        especialidade: payload.especialidade,
        localizacao: payload.localizacao,
        codigoStatus: payload.codigoStatus,
        subTenant4Health: payload.subTenant4Health,
        tenant: payload.tenantD4Health,
        d4HToken: payload.d4HToken
      },
      headers: noTenant()
    })
  }


  findAgendaProfessional(payload) {
    return Vue.prototype.$axios.get(apiUrl + "/agendamento-sgh/horarios", {
      params: {
        agenda: payload.agenda,
        conselho: payload.conselho,
        convenio: payload.convenio,
        telehealth: payload.telehealth,
        dataFinal: payload.dataFinal,
        dataInicial: payload.dataInicial,
        especialidade: payload.especialidade,
        localizacao: payload.localizacao,
        subTenant4Health: payload.subTenant4Health,
        tenant4Health: payload.tenant4Health
      },
      headers: noTenant()
    });
  }

  findAgendaProfessionalCallCenter(payload) {
    return Vue.prototype.$axios.get(apiUrl + "/agendamento-sgh/horarios-call-center", {
      params: {
        agenda: payload.agenda,
        conselho: payload.conselho,
        convenio: payload.convenio,
        telehealth: payload.telehealth,
        dataFinal: payload.dataFinal,
        dataInicial: payload.dataInicial,
        especialidade: payload.especialidade,
        localizacao: payload.localizacao,
        tenant: payload.tenant,
        subTenant4Health: payload.subTenant4Health,
        tenant4Health: payload.tenant4Health,
        d4HToken: payload.d4HToken
      },
      headers: noTenant()
    });
  }

  // Ocupacao por dia (agendamentos nao cancelados) de uma agenda: { 'YYYY-MM-DD': qtd }.
  // Cruzada com os horarios livres, define a cor de cada dia no calendario do call center.
  findOcupacaoCalendarioCallCenter(payload) {
    return Vue.prototype.$axios.get(apiUrl + "/agendamento-sgh/ocupacao-calendario-call-center", {
      params: {
        agenda: payload.agenda,
        dataInicial: payload.dataInicial,
        dataFinal: payload.dataFinal,
        subTenant4Health: payload.subTenant4Health,
        tenant: payload.tenant,
        d4HToken: payload.d4HToken
      },
      headers: noTenant()
    });
  }

  findDatasAgendaProfessional(payload) {
    const dataInicio = Date.now()
    const dataInicioFormatada = date.formatDate(dataInicio, 'YYYY-MM-DD')
    return Vue.prototype.$axios.get(apiUrl + "/agendamento-sgh/datas-horarios", {
      params: {
        agenda: payload.agenda,
        conselho: payload.conselho,
        convenio: payload.convenio,
        dataInicial: dataInicioFormatada,
        especialidade: payload.especialidade,
        localizacao: payload.localizacao,
        subTenant4Health: payload.subTenant4Health,
        tenant: payload.tenant
      },
      headers: noTenant(),
      cancelToken: payload.cancelToken
    });
  }

  findLocalidade(payload) {
    return Vue.prototype.$axios.get(apiUrl + "/localidade-sgh/hospitais", {
      params: {
        subTenant4Health: payload.subTenant4Health,
        tenant: payload.tenant,
        d4HToken: payload.d4HToken
      },
      headers: noTenant()
    });
  }

  findLocalidadeSGHDigital(payload) {
    return Vue.prototype.$axios.get(apiUrl + "/localidade-sgh/hospitais-sgh-digital", {
      params: {
        subTenant4Health: payload.subTenant4Health,
        tenant: payload.tenant,
        d4HToken: payload.d4HToken
      },
      headers: noTenant()
    });
  }

  findSpecialty(payload) {
    return Vue.prototype.$axios.get(apiUrl + "/especialidades-sgh", {
      params: {
        convenio: payload.convenio,
        subTenant4Health: payload.subTenant4Health,
        medico: payload.medico,
        tenant: payload.tenant,
        d4HToken: payload.d4HToken
      },
      headers: noTenant()
    });
  }

  findConvenios(payload) {
    return Vue.prototype.$axios.get(apiUrl + "/agendamento-sgh/convenios", {
      params: {
        conselho: payload.conselho,
        convenio: payload.convenio,
        dataFinal: payload.dataFinal,
        dataInicial: payload.dataInicial,
        especialidade: payload.especialidade,
        localizacao: payload.localizacao,
        subTenant4Health: payload.subTenant4Health,
        tenant: payload.tenant,
        d4HToken: payload.d4HToken
      },
      headers: noTenant()
    });
  }

  findStatus(payload) {
    return Vue.prototype.$axios.get(apiUrl + "/status-sgh", {
      params: {
        codigo: payload.codigo,
        tenant: payload.tenant,
        subTenant4Health: payload.subTenant4Health,
        d4HToken: payload.d4HToken
      },
      headers: noTenant()
    });
  }

  findIndividuals(payload, cancelToken) {
    return Vue.prototype.$axios.get(apiUrl + "/users-individuals", {
      params: {
        name: payload?.name,
        page: payload?.page,
        cpf: payload?.cpf,
        startDateOfBirth: payload?.startDateOfBirth,
        endDateOfBirth: payload?.endDateOfBirth,
        similarityPercentual: payload.similarityPercentual,
        size: payload.size,
        tenant: payload.tenant,
        subTenant4Health: payload.subTenant4Health,
        d4HToken: payload.d4HToken
      },
      headers: noTenant(),
      cancelToken
    });
  }
  

  findIndividualCPFSGH(payload) {
    return Vue.prototype.$axios.get(apiUrl + "/users-individuals/sgh", {
      params: {
        cpfPaciente: payload?.cpf,
        subTenant4Health: payload.subTenant4Health,
        tenant: payload.tenant
      },
      headers: noTenant()
    });
  }

  getLogo(cliente) {
    return Vue.prototype.$axios.get(apiUrl + `/tenant/logo-cliente/${cliente}`, {
      headers: noTenant()
    });
  }

  findCities(payload) {
    return Vue.prototype.$axios.get(apiUrl + `/tenant/find-cidade`, {
      params: {
        nome: payload?.name || undefined,
        page: payload?.page,
        size: payload?.size,
        sort: payload?.sort,
        codigoIBGESemDigito: payload?.codigoIBGESemDigito || undefined,
        tenant: payload.tenant,
        subTenant4Health: payload.subTenant4Health,
        d4HToken: payload.d4HToken
      },
      headers: withTenant(payload.tenant)
    });
  }

  realizarAgendamento (payload) {
    return Vue.prototype.$axios.post(apiUrl + "/agendamento-sgh", payload, {
      headers: noTenant()
    });
  }

  realizarAgendamentoCallCenter (payload) {
    return Vue.prototype.$axios.post(apiUrl + "/agendamento-sgh/agendar-paciente-4Health-call-center", payload, {
      params: {
        d4HToken: payload.d4HToken,
        tenant: payload.tenant,
        subTenant4Health: payload.subTenant4Health
      },
      headers: noTenant()
    });
  }

  realizarReAgendamentoCallCenter (payload) {
    return Vue.prototype.$axios.post(apiUrl + "/agendamento-sgh/reagendar-call-center", payload, {
      params: {
        d4HToken: payload.d4HToken,
        tenant: payload.tenant,
        subTenant4Health: payload.subTenant4Health
      },
      headers: noTenant()
    });
  }

  excluirAgendamento (payload) {
    return Vue.prototype.$axios.delete(apiUrl + "/agendamento-sgh/cancelar-call-center", {
      params: {
        appLid: payload.appLid,
        tenant: payload.tenant,
        subTenant4Health: payload.subTenant4Health,
        d4HToken: payload.d4HToken
      },
      headers: noTenant()
    })
  }

  atualizarAgendamento (payload) {
    return Vue.prototype.$axios.patch(apiUrl + "/agendamento-sgh/agendamento-call-center", payload, {
      params: {
        d4HToken: payload.d4HToken,
        tenant: payload.tenant,
        subTenant4Health: payload.subTenant4Health
      },
      headers: noTenant()
    });
  }

  incluirAgendamento (payload) {
    return Vue.prototype.$axios.post(apiUrl + "/agendamento-sgh/insert-agenda-call-center", payload, {
      params: {
        tenant: payload.tenant,
        subTenant4Health: payload.subTenant4Health,
        d4HToken: payload.d4HToken
      },
      headers: noTenant()
    });
  }

  atualizarPaciente(payload) {
  return Vue.prototype.$axios.put(apiUrl + "/users-individuals/atualizar-paciente", payload, {
    params: {
      d4HToken: payload.d4HToken,
      tenant: payload.tenant,
      subTenant4Health: payload.subTenant4Health
    },
    headers: noTenant()
  });
}

  atualizarTipoAgendamento(payload) {
    return Vue.prototype.$axios.patch(apiUrl + "/agendamento-sgh/agendamento-call-center", payload, {
      params: {
        d4HToken: payload.d4HToken,
        tenant: payload.tenant,
        subTenant4Health: payload.subTenant4Health
      },
      headers: noTenant()
    });
  }

  adicionarPaciente (payload) {
    return Vue.prototype.$axios.post(apiUrl + "/users-individuals/adicionar", payload, {
      params: {
        d4HToken: payload.d4HToken,
        tenant: payload.tenant,
        subTenant4Health: payload.subTenant4Health
      },
       headers: noTenant()
    });
  }

  getCpfObrigatorio(cliente) {
    return Vue.prototype.$axios.get(apiUrl + `/tenant/cpf-obrigatorio/${cliente}`, {
      headers: noTenant()
    });
  }

  getTipoAgendamentoSgh(cliente) {
    return Vue.prototype.$axios.get(apiUrl + `/tenant/has-tipo-agendamento-sgh/${cliente}`, {
      headers: noTenant()
    });
  }

  getAppointmentTypes(payload) {
    if (appointmentTypesCache) {
      return Promise.resolve({ data: appointmentTypesCache });
    }
    if (appointmentTypesPromise) {
      return appointmentTypesPromise;
    }
    appointmentTypesPromise = Vue.prototype.$axios.get(apiUrl + `/agendamento-sgh/tipos-agendamento-call-center`, {
      params: {
        subTenant4Health: payload.subTenant4Health,
        tenant: payload.tenant,
        d4HToken: payload.d4HToken
      },
      headers: noTenant()
    }).then(response => {
      appointmentTypesCache = response.data;
      appointmentTypesPromise = null;
      return response;
    }).catch(e => {
      appointmentTypesPromise = null;
      throw e;
    });
    return appointmentTypesPromise;
  }

  findFeriados(payload) {
    // Usa instância pura de axios sem o interceptor de auth-refresh
    // O endpoint /api/feriados é público (permitAll) e não precisa de Bearer token.
    // Usar Vue.prototype.$axios causaria falha em cascata quando outro request
    // aciona o refresh do token (que falha no contexto callcenter).
    return axios.get(apiUrl + "/api/feriados", {
      params: {
        subTenant4Health: payload.subTenant4Health,
        HOLI_START_DATE: payload.HOLI_START_DATE
      },
      headers: noTenant()
    });
  }

  loginDigital4Health(payload) {
    return Vue.prototype.$axios.get(apiUrl + "/login-digital", {
      params: {
        tenant: payload.tenant,
        subTenant4Health: payload.subTenant4Health,
        d4HToken: payload.d4HToken
      },
      headers: noTenant()
    });
  }

  getGeneralPatientParameter(payload) {
    return Vue.prototype.$axios.get(apiUrl + "/general-patient-parameter-sgh", {
      params: {
        subTenant4Health: payload.subTenant4Health,
        tenant4Health: payload.tenant4Health,
        typeAgenda: payload.typeAgenda,
        d4HToken: payload.d4HToken,
        tenant: payload.tenant
      },
      headers: noTenant()
    });
  }

  redirectLogin(e){
    if(e.response?.request?.status === 500){
      redirectToDigitalLogin()
    }
  }
}
export default new SGHService();